import * as TagLayout from './StatusTag.styles.js';
import {
  type StatusTagBorderRadius,
  StatusTagSize,
  type StatusTagVariant,
  type StatusTagVersion,
} from './types.js';
import { type IconSvgProps } from '@contra/icons/icons';
import { type ComponentType } from 'react';

export type StatusTagProps = {
  readonly borderRadius?: StatusTagBorderRadius;
  readonly icon?: ComponentType<IconSvgProps>;
  readonly label: React.ReactNode | string;
  readonly onClick?: () => void;
  readonly role?: string;
  readonly size?: StatusTagSize;
  readonly variant?: StatusTagVariant;
  readonly version?: StatusTagVersion;
  readonly width?: string;
};

export const StatusTag = ({
  borderRadius = 'pill',
  icon: Icon,
  label,
  size = 'small',
  variant = 'default',
  version = 'v1',
  width = 'auto',
  ...props
}: StatusTagProps) => {
  return (
    <TagLayout.Container
      aria-label={typeof label === 'string' ? label : undefined}
      role="status"
      {...props}
      $borderRadius={borderRadius}
      $size={size}
      $variant={variant}
      $version={version}
      $width={width}
    >
      {Icon ? (
        <TagLayout.IconContainer
          $size={size}
          $variant={variant}
          $version={version}
        >
          <Icon size={16} />
        </TagLayout.IconContainer>
      ) : null}
      <TagLayout.Label
        $size={size}
        as="span"
        textStyle={version === 'v1' ? 'captionBold' : 'overlineRegular'}
      >
        {label}
      </TagLayout.Label>
    </TagLayout.Container>
  );
};
